import type { MissingFieldsData } from '@/state/navigation';
import { computeMissingContactFields } from '../shared/missingFields';
import { buildContactsSchema } from '../shared/schema';
import type { ContactsFormData, ContactType } from '../shared/types';
import {
  getRequiredContactFields,
  type OfferContactsConfig,
} from './formConfig';

const ROLE_LABELS: Record<ContactType, string> = {
  agent: "Buyer's Agent",
  client: 'Buyer',
  counterpartyAgent: "Seller's Agent",
  counterpartyClient: 'Seller',
  counterpartyTransactionCoordinator: "Seller's Transaction Coordinator",
  titleOfficer: 'Title Officer',
  escrowOfficer: 'Escrow Officer',
  lender: 'Lender',
  appraiser: 'Appraiser',
  attorney: 'Attorney',
  counterpartyAttorney: "Seller's Attorney",
  closingAttorney: 'Closing Attorney',
  propertyManagingAgent: 'Property Managing Agent',
  homeWarranty: 'Home Warranty',
  other: 'Other Contact',
};

export function computeMissingOfferContactFields(
  formData: ContactsFormData,
  config: OfferContactsConfig,
): MissingFieldsData[] {
  const schema = buildContactsSchema(getRequiredContactFields(config));
  return computeMissingContactFields(formData, {
    schema,
    roleLabels: ROLE_LABELS,
  });
}
